import React, { useState } from 'react'
import { useNavigate } from 'react-router'

const TextInput: React.FC = () => {
  const [inputValue, setInputValue] = useState('')
  const [isFocused, setIsFocused] = useState(false)
  const navigate = useNavigate()

  
  const handleFocus = () => {
    setIsFocused(true)
  } 
  const handleBlur = () => setIsFocused(inputValue !== '')

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value)
  }

  const handleArrowClick = () => {
    if (inputValue) navigate(`/mutual-fund/${inputValue}`)
  }

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      handleArrowClick()
    }
  }

  return (
    <div className='relative w-full max-w-80 mx-[20px]'>
      <input
        id='text-input'
        type='text'
        value={inputValue}
        onFocus={handleFocus}
        onBlur={handleBlur}
        onChange={handleChange}
        onKeyDown={handleKeyDown} // Add this line for the Enter key handler
        placeholder='Type ISIN...'
        className={`w-full px-4 py-3 pr-12 border-2 rounded-md bg-white text-gray-800 
          ${isFocused ? 'border-gray-500' : 'border-gray-200'} 
          focus:outline-none
          transition-all ease-in-out duration-300`}
      />

      <button
        onClick={handleArrowClick}
        disabled={!inputValue}
        className='absolute right-4 top-1/2 transform -translate-y-1/2 bg-gray-200 text-gray-800 p-2 rounded-full hover:bg-gray-300 transition-colors hover:border-gray-50'
      >
        <svg
          xmlns='http://www.w3.org/2000/svg'
          viewBox='0 0 24 24'
          fill='none'
          stroke='currentColor'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
          className='w-5 h-5'
        >
          <path d='M9 18l6-6-6-6' />
        </svg>
      </button>
    </div>
  )
}

export default TextInput
